export * from './forTesting.tmpl';
export * from './TefComs4p';
export * from './tefComsButton.tmpl';
export * from './tefComsCancelButton.tmpl';
